// @flow
import createMaybeTransform from 'app/common/react/components/closeup/utils/createMaybeTransform';
import type { HasPin, MaybeAToMaybeAB } from 'app/common/react/components/closeup/utils/types';

type HasLink = {
  link: string,
};

type ToMaybeHasLink = MaybeAToMaybeAB<HasPin, HasLink>;

const hasLink: ToMaybeHasLink = createMaybeTransform((props) => {
  const { pin } = props,
    { tracked_link: trackedLink, link: pinLink } = pin,
    link = trackedLink || pinLink;
  return link ? { ...props, link } : null;
});

export default hasLink;
